import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import Config from "../Config";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuthHandling } from '../useAuthhandling';

function List() {
  let navigate = useNavigate();
  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [servicedata, setServicedata] = useState([]);
  const params = useParams();
  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/service/get-service-list`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );

    if (res.status === 200 ) {
      const data = await res.json();

      setServicedata(data.data);

    }
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

  useEffect(() => {
    getinfo();
  }, []);

  const deleteservice = async (id) => {
    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/service/delete-service/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200 ) {
      toast.success("Sucessfully deleted", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      getinfo();
      
    } 
    else if(response.status === 401){
      handleUnauthorized();
      deleteservice(id);
    }
    else {
      const deletedata = await response.json();

      console.log("error");
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Service List</h4>
                    <div className="table-responsive pt-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Service Name</th>

                            <th>Image</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {servicedata.map((element) => {
                            return (
                              <>
                                <tr>
                                  <td>{element.serviceName}</td>

                                  <td>
                                    <img
                                      src={element.serviceImg}
                                      width="50"
                                      alt=""
                                    />
                                  </td>
                                  <td>
                                    <button
                                      onClick={() => deleteservice(element._id)}
                                      className="margins-2"
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </button>
                                    <button>
                                      <Link
                                        to={"/editservice/" + element._id}
                                        className="fa-solid fa-pen"
                                        style={{ color: "black" }}
                                      ></Link>
                                    </button>
                                    <ToastContainer />
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default List;
